module.exports = __webpack_public_path__ + "static/media/Veigar.96677bbd.png";